import { render, staticRenderFns } from "./heading.vue?vue&type=template&id=49f29b9a&"
import script from "./heading.vue?vue&type=script&lang=ts&"
export * from "./heading.vue?vue&type=script&lang=ts&"
import style0 from "./heading.vue?vue&type=style&index=0&id=49f29b9a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports